__webpack_require__.p = "/referrals-textarea-nng8ap/referrals/";